import { Window } from "@progress/kendo-react-dialogs";

export interface ProductTourProps {
  url: string;
  onClose: () => void;
  width?: number;
  height?: number;
}

const ProductTour = ({ props }: { props: ProductTourProps }) => {
  const { onClose, url } = props;
  return (
    <>
      <Window
        modal
        draggable={false}
        resizable={false}
        className="product-tour"
        // title="Product Tour"
        width={props.width || 987}
        height={props.height || 574}
        onClose={onClose}
        style={{ padding: "0" }}
        overlayStyle={{ padding: "0", display: "relative" }}
      >
        <iframe
          name="product-tour-iframe"
          height={props.height - 4 || 570}
          width={props.width - 4 || 985}
          className="flex grow"
          src={url}
        />
      </Window>
    </>
  );
};

export default ProductTour;
